import React, { useState }  from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import TooltipWrapper from "src/components/Common/TooltipWrapper";
import { WorkflowIcon } from "src/components/Common/Icons";
import { useMutation, useQuery } from "src/Hooks/useReactQuery";
import { triggerAutomationWorkflow } from "src/services/auth";
import { getSeriesInput } from "src/services/simulator-flight";
import { useSetRecoilState } from 'recoil';
import { alertState } from 'src/recoil/atoms/global';
import { WORKFLOW_SIMULATION_TYPE, AUTOMATION_STATUS_CLASSNAME, PROCESS_STATUS } from "src/constant/common";

const ButtonTrigger = ({ isShow = true, simulationData, serieData, id }) => {
  const { t } = useTranslation("flight-simulator");
  const showAlert = useSetRecoilState(alertState);
  const [automationStatus, setAutomationStatus] = useState(serieData.automation_status?.toUpperCase());
  const [automationErrorMsg, setAutomationErrorMsg] = useState(serieData.automation_error_message || null);

  const triggerWorkflowMutate = useMutation({
    mutationFn: ({data}) => triggerAutomationWorkflow({data}),
  });

  useQuery({
    queryKey: [`getWorkflowStatus_${simulationData.id}_${serieData.serie_name}`],
    queryFn: () => getSeriesInput(simulationData.id),
    enabled: automationStatus === PROCESS_STATUS.RUNNING,
    onSuccess: (data) => {
      const finalData = data?.params || data;
      finalData?.forEach((serie) => {
        if (serie.serie_name === serieData.serie_name) {
          setAutomationStatus(serie.automation_status?.toUpperCase());
          setAutomationErrorMsg(serie.automation_error_message || null);
        }
      });
    },
    refetchInterval: 5000,
  });

  const getIconColor = () => {
    return automationStatus ? AUTOMATION_STATUS_CLASSNAME[automationStatus.toUpperCase()] : "text-dark";
  }

  const handleClickTrigger = async () => {
    const data = {
      simulation_id:simulationData.id,
      simulation_type: WORKFLOW_SIMULATION_TYPE[simulationData.type],
      serie_name: serieData.serie_name,
      serie_file_name: serieData.serie_file_name,
    }
    try {
      const response = await triggerWorkflowMutate.mutateAsync({ data });
      setAutomationStatus(response.status?.toUpperCase());
      setAutomationErrorMsg(response.error_message || null);
      showAlert({
        status: true,
        message: t("workflow_success"),
        type: "success",
      });
    } catch (error) {
      showAlert({
        status: true,
        message: error?.response?.data?.error?.detail || error?.message,
        type: "danger",
      });
    }
  }
  return isShow ? (
    triggerWorkflowMutate.isLoading ? (
      <Spinner size="sm" color="secondary" className="mx-1" />
    ) : (
      <TooltipWrapper
        id={`bt-trigger-${id}`}
        tooltipText={automationErrorMsg || t("workflow_tooltip")}
      >
        <button
          className="btn btn-blank border-0 p-0"
          onClick={() => handleClickTrigger()}
          onFocus={(e) => {
            e.target.blur();
          }}
          disabled={automationStatus === PROCESS_STATUS.RUNNING}
        >
          <WorkflowIcon className={getIconColor()} size={25} />
        </button>
      </TooltipWrapper>
    )
  ) : null;
};

export {
  ButtonTrigger
};
